import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getFormNodeLogicRules } from 'common/entities/formLogicRule/selectors';

import {
    getDropParentNodeId,
    getDropNodePosition,
    getDragNodePosition,
    getDragNodeId,
    getDropNodeId,
    getBootstrap,
    getFormNodeWithMappedLabel,
} from '../../selectors';
import { openEditFormNode, openEditFormNodeLogic, duplicateFormNodeWithAdditionalGuests } from '../../actions';
import { removeFormNode } from '../../actions/nodeActions';
import { openFormTemplateLibrary } from '../../actions/templateLibrary';
import { beginDragFormNode, endDragFormNode, hoverDropFormNode } from '../../actions/dragActions';
import { INPUT_TYPE_DISPLAY_NAMES } from '../../constants/bootstrapKeys';

import LayoutNode from './LayoutNode';

const mapStateToProps = (state, props) => {
    const { formNodeId } = props;
    const formNode = getFormNodeWithMappedLabel(state, formNodeId);
    const formLogicRules = getFormNodeLogicRules(state, formNode.formId, formNodeId);
    const dropParent = getDropParentNodeId(state);

    const isDropParent = dropParent === formNodeId;
    const dropNodePosition = isDropParent ? getDropNodePosition(state) : null;
    const dragNodePosition = isDropParent ? getDragNodePosition(state) : null;
    const dragNodeId = isDropParent ? getDragNodeId(state) : null;
    const dropNodeId = isDropParent ? getDropNodeId(state) : null;

    const bootstrap = getBootstrap(state);

    return {
        formNode,
        formLogicRules,
        dropParent,
        dropNodePosition,
        dragNodePosition,
        dragNodeId,
        dropNodeId,
        bootstrapInputTypeDisplayNames: bootstrap[INPUT_TYPE_DISPLAY_NAMES],
    };
};

const mapDispatchToProps = {
    beginDragFormNode,
    endDragFormNode,
    hoverDropFormNode,
    openEditFormNode,
    openEditFormNodeLogic,
    duplicateFormNode: duplicateFormNodeWithAdditionalGuests,
    removeFormNode,
    openFormTemplateLibrary,
};

const ConnectedLayoutNode = connect(mapStateToProps, mapDispatchToProps)(LayoutNode);
ConnectedLayoutNode.propTypes = {
    formNodeId: PropTypes.string.isRequired,
};
export default ConnectedLayoutNode;
